import { render, staticRenderFns } from "./ZHMingxi.vue?vue&type=template&id=dc2c5b68&scoped=true&"
import script from "./ZHMingxi.vue?vue&type=script&lang=js&"
export * from "./ZHMingxi.vue?vue&type=script&lang=js&"
import style0 from "./ZHMingxi.vue?vue&type=style&index=0&id=dc2c5b68&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc2c5b68",
  null
  
)

export default component.exports